import { render, staticRenderFns } from "./CreateOrderCard.vue?vue&type=template&id=b2f5b44a&"
import script from "./CreateOrderCard.vue?vue&type=script&lang=js&"
export * from "./CreateOrderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports